import { ResearchedTransaction } from '@treasury/domain/accounts';

const mapDateRange = (dateRange: any) => {
    if (dateRange === 'today') {
        return {
            transactionDateOperator: 'Today',
            transactionDateFrom: new Date().toLocaleDateString('en-US'),
            transactionDateTo: new Date().toLocaleDateString('en-US'),
        };
    }
    if (dateRange.dates) {
        const [startDate, endDate] = dateRange.dates;
        return {
            transactionDateOperator: dateRange.label,
            transactionDateFrom: startDate.toLocaleDateString('en-US'),
            transactionDateTo: endDate
                ? endDate.toLocaleDateString('en-US')
                : startDate.toLocaleDateString('en-US'),
        };
    }
    return {};
};
export const mapCheckRange = (checkRange: any) => {
    const [checkRangeType, checkRangeValueStart, checkRangeValueEnd] = checkRange;
    return {
        referenceNumberOperator: checkRangeType,
        referenceNumberFrom: checkRangeValueStart ? checkRangeValueStart : null,
        referenceNumberTo: checkRangeValueEnd ? checkRangeValueEnd : null,
    };
};
export const mapAmountRange = (amountRange: any) => {
    const [amountRangeType, amountFrom, amountTo] = amountRange;
    return {
        amountOperator: amountRangeType,
        amountFrom: amountFrom ? amountFrom : null,
        amountTo: amountTo ? amountTo : null,
    };
};

export const mapCheckLookupFilters = (filters: any) => {
    return {
        accounts: filters.accounts,
        ...mapDateRange(filters.dateRange),
        ...mapCheckRange(filters.checkNumber),
        ...mapAmountRange(filters.amountRange),
        paymentDirection: 'Both',
        accountTypes: [{ name: 'Checking' }, { name: 'Savings' }],
        // paymentTypes: [{ type: 'Check' }], - payments of type 'Check' are not returned by the API when filtered
        maxRecordCount: 50000,
    };
};

export const filterResultsToCheckLookup = (filterResults: ResearchedTransaction[]) =>
    filterResults.filter((trans: ResearchedTransaction) => trans.checkNumber);
